import { randomBytes } from 'crypto'

export function rand (size = 64) {
  return randomBytes(Math.ceil(3 * size / 4))
    .toString('base64')
    .substring(0, size)
}
